import type { IPushNotificationBody } from '@infor/core/models/push-notification';

import { queryKeys } from 'constants/query-keys.cache';
import { queryClient } from 'lib/tanstack-query/TanstackProvider';

export const invalidateNotificationQueries = (
  _newPushNotification: IPushNotificationBody
) => {
  void queryClient.invalidateQueries({
    queryKey: [queryKeys.ALUNO_COMUNICADOS],
    exact: false,
    refetchType: 'active',
  });
};
